import React from 'react';
import { handleClickCard } from "../../../../functions/functions";

export default function ScoreTenislComponent({ item, isFinished, rightIsWinner, leftIsWinner }) {
  const { opta_event_url, tenis_data, class: cs } = item;
  const { left_stats, right_stats } = tenis_data || {};
  const { left_tenis_score = [] } = left_stats || {};
  const { right_tenis_score = [] } = right_stats || {};

  const ScoreSection = ({ scores, posession, isWinner }) => (
    <div className={isWinner ? "card-body-right-tres-winner" : "card-body-right-tres"}>
      <div className="span-score-div">
        {/* {posession && cs ==='clarosports-in-progress-game' ? <div className='ball-tenis'></div> : <div className='ball-tenis-default'></div>} */}
        {Array.isArray(scores) && scores.map((s, idx) => {
          // Validar si mostrar tiebreak comparando ambos equipos
          const leftTiebreak = left_tenis_score?.[idx]?.tiebreak || 0;
          const rightTiebreak = right_tenis_score?.[idx]?.tiebreak || 0;
          const shouldShowTiebreak = leftTiebreak > 0 || rightTiebreak > 0;
          
          return (
            <React.Fragment key={idx}>
              <span
                className={s?.is_higher && !isFinished ? "span-winner" : "span-score"}
              >
                {s?.score || 0}
              </span>
              {shouldShowTiebreak && <div className={s?.is_higher && !isFinished ? "score-tie-winner": "score-tie"}>{s?.tiebreak || 0}</div>}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );

  return (
    <div className="card-body-right cursorAuto" style={{ justifyContent: 'left' }} onClick={(e) => handleClickCard(e, opta_event_url)}>
      <ScoreSection scores={left_tenis_score} posession={left_stats?.first_server} isWinner={leftIsWinner} />
      <ScoreSection scores={right_tenis_score} posession={right_stats?.first_server} isWinner={rightIsWinner} />
    </div>
  );
}